export default [
  {
    path: '/reports/my-reports',
    name: 'my-reports',
    component: () => import('@/views/reports/my-reports/Reports.vue'),
  },
]
